// src\Redux\LanguageSlice.ts
import { createSlice } from "@reduxjs/toolkit";
const savedLang = localStorage.getItem("lang");
const initialState = {
  language: savedLang || "en",
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload;
      localStorage.setItem("lang", state.language)
    },
    ensurePartnerDefaultLanguage(state) {
      const saved = localStorage.getItem("lang");
      if (saved) return;
      state.language = "zh";
      localStorage.setItem("lang", "zh");
    },
  },
});

export const { setLanguage, ensurePartnerDefaultLanguage } = languageSlice.actions;
export default languageSlice.reducer;
